<template>
  <v-card
  max-width="800"
  class="main--text"
    >
    <v-form>
      <v-container
        fluid>
        <v-row
          no-gutters
          align=center
          justify=space-between>
          <v-col
            cols=auto
            >
            <span class="font-weight-bold" style="font-size:1.3rem">ご登録情報変更画面</span>
          </v-col>
          <v-col
            cols=auto>
              <v-icon
                @click="$emit('return-button-click')">mdi-arrow-left-circle</v-icon>
          </v-col>
        </v-row>
        <v-row
          dense
          >
          <v-col
            md=6>
            <v-text-field
              v-model="familyName"
              label="姓"
              type="text"
              v-validate="'required'"
              data-vv-name="familyName"
              data-vv-as="名字"
              required
              :error-messages="errors.collect('familyName')"
            >
            </v-text-field>
          </v-col>
          <v-col
            cols=12
            md=6
            sm=6>
            <v-text-field
              v-model="personalName"
              label="名"
              type="text"
              v-validate="'required'"
              data-vv-name="personalName"
              data-vv-as="名前"
              required
              :error-messages="errors.collect('personalName')"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          dense
          >
          <v-col
            cols=12
            md=6
            sm=6>
            <v-text-field
              v-model="flatFamilyName"
              label="セイ"
              type="text"
              v-validate="'required'"
              data-vv-name="flatFamilyName"
              data-vv-as="名字（カナ）"
              required
              :error-messages="errors.collect('flatFamilyName')"
            >
            </v-text-field>
          </v-col>
          <v-col
            cols=12
            md=6
            sm=6>
            <v-text-field
              v-model="flatPersonalName"
              label="メイ"
              type="text"
              v-validate="'required'"
              data-vv-name="flatPersonalName"
              data-vv-as="名前（カナ）"
              required
              :error-messages="errors.collect('flatPersonalName')"
            >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          no-gutters>
          <v-col>
            <v-radio-group
              v-model="gender"
              row
              v-validate="'required'"
              data-vv-name="gender"
              data-vv-as="性別"
              required
              :error-messages="errors.collect('gender')"
              >
              <v-radio
                label="男性"
                value="male">
              </v-radio>
              <v-radio
                label="女性"
                value="female">
              </v-radio>
            </v-radio-group>
          </v-col>
        </v-row>
        <v-row
          dense
          >
          <v-col
            md=6
            cols=12>
            <BirthdayPicker
              v-model="birthday" />
          </v-col>
        </v-row>
        <v-row
          dense
          >
          <v-col
            md=6
            cols=12
            >
            <v-text-field
              v-model="phone"
              label="電話番号(ハイフンなし)"
              type="text"
              v-validate="'required|numeric'"
              data-vv-name="phone"
              data-vv-as="電話番号"
              required
              :error-messages="errors.collect('phone')"
              >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          dense
          >
          <v-col
            md=6
            sm=6
            cols=auto>
            <v-text-field
              v-model="postalCode"
              label="郵便番号(ハイフンなし７ケタ)"
              type="text"
              v-validate="'required|numeric'"
              data-vv-name="postalCode"
              data-vv-as="郵便番号"
              required
              :error-messages="errors.collect('postalCode')"
              >
            </v-text-field>
          </v-col>
          <v-col
          sm=6
          cols=auto>
            <v-btn
              rounded
              outlined
              @click="$emit('address-button-click')"><v-icon>mdi-map-search-outline</v-icon>住所検索</v-btn>
          </v-col>
        </v-row>
        <v-row
          dense>
          <v-col
            md=6
            cols=12>
            <v-select
              v-model="prefecture"
              :items="prefectures"
              label="都道府県"
              type="text"
              v-validate="'required'"
              data-vv-name="prefecture"
              data-vv-as="都道府県"
              required
              :error-messages="errors.collect('prefecture')"
              >
            </v-select>
          </v-col>
          <v-col
            md=6
            cols=12>
            <v-text-field
              v-model="municipality"
              label="市区町村"
              type="text"
              v-validate="'required'"
              data-vv-name="municipality"
              data-vv-as="市区町村"
              required
              :error-messages="errors.collect('municipality')"
              >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols=12>
            <v-text-field
              v-model="subAddress"
              label="下位住所"
              type="text"
              v-validate="'required'"
              data-vv-name="subAddress"
              data-vv-as="下位住所"
              required
              :error-messages="errors.collect('subAddress')"
              >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols=12
            md=6>
            <v-text-field
              v-model="nearestStation"
              label="最寄り駅"
              type="text">
            </v-text-field>
          </v-col>
        </v-row>
        <v-row
          justify=start
          >
          <v-col>
            <v-btn
              depressed
              rounded
              outlined
              color="primary"
              @click="update"
              >更新
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <v-dialog
      v-model="dialog"
      max-width="300"
      persistent>
      <v-card>
        <v-container
          fluid>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              登録情報を更新しました！
            </v-col>
          </v-row>
          <v-row
            justify=center>
            <v-col
              cols=auto>
              <v-btn
                depressed
                outlined
                rounded
                color='primary'
                @click="toDisplayProfile"
                >
                OK
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-card>
</template>

<script>
import BirthdayPicker from "@/components/molecules/BirthdayPicker.vue"
import { prefectures } from '@/models/Regions'

export default {
  components: {
    BirthdayPicker
  },
  props: {
    value: Object
  },
  data () {
    return {
      birthdayMenu: null,
      dialog: false,
      prefectures: prefectures
    }
  },
  methods: {
    update () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit("update-button-click")
          this.dialog = true
        }
      })
    },
    toDisplayProfile () {
      this.dialog = false
      this.$emit("return-button-click")
    },
    updateValue (diff) {
      this.$emit("input", { ...this.value, ...diff })
    }
  },

  computed: {
    name: {
      get() {
        return this.value.name
      },
      set(name) {
        this.updateValue({ name })
      }
    },
    personalName: {
      get () {
        return this.name.personalName
      },
      set (personalName) {
        this.name = { ...this.name, personalName }
      }
    },
    familyName: {
      get () {
        return this.name.familyName
      },
      set (familyName) {
        this.name = { ...this.name, familyName }
      }
    },
    flatPersonalName: {
      get () {
        return this.name.flatPersonalName
      },
      set (flatPersonalName) {
        this.name = { ...this.name, flatPersonalName }
      }
    },
    flatFamilyName: {
      get () {
        return this.name.flatFamilyName
      },
      set (flatFamilyName) {
        this.name = { ...this.name, flatFamilyName }
      }
    },
    gender: {
      get() {
        return this.value.gender
      },
      set (gender) {
        this.updateValue({ gender })
      }
    },
    birthday: {
      get() {
        return this.value.birthday
      },
      set (birthday) {
        this.updateValue({ birthday })
      }
    },
    phone: {
      get() {
        return this.value.phone
      },
      set (phone) {
        this.updateValue({ phone })
      }
    },
    address: {
      get() {
        return this.value.address
      },
      set(address) {
        this.updateValue({ address })
      }
    },
    postalCode: {
      get () {
        return this.address.postalCode
      },
      set (postalCode) {
        this.address = { ...this.address, postalCode}
      }
    },
    prefecture: {
      get () {
        return this.address.prefecture
      },
      set (prefecture) {
        this.address = { ...this.address, prefecture }
      }
    },
    municipality: {
      get () {
        return this.address.municipality
      },
      set(municipality) {
        this.address = { ...this.address, municipality }
      }
    },
    subAddress: {
      get () {
        return this.address.subAddress
      },
      set (subAddress) {
        this.address = { ...this.address, subAddress }
      }
    },
    nearestStation: {
      get () {
        return this.value.nearestStation
      },
      set (nearestStation) {
        this.updateValue({ nearestStation })
      }
    },
    cardId: {
      get () {
        return this.value.cardId
      },
      set (cardId) {
        this.updateValue({ cardId })
      }
    }
  }
}
</script>
